<template>
  <div>
    <div class="more-content is-screen" :class="{ 'is-collapsed' : hidden }" :style="{ height: height + 'px' }" ref="showMoreContainer" @click="toggleIfHidden" tabindex="0" @focus="expand">
      <div>
        <slot></slot>
      </div>
    </div>
    <div class="more-content is-print">
      <div>
        <slot></slot>
      </div>
    </div>
    <div class="toggle-container is-hidden-print" :class="{ 'text-only-toggle' : textOnly }" v-if="!contentFits">
      <div @click.prevent="toggle" @keyup.enter="toggle">
				<span tabindex="0" :class="{ 'is-collapsed' : hidden, 'button is-large' : !textOnly }">
	        		<i class="far fa-plus" v-if="textOnly"></i> {{ label }}
				</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShowMore',

  props: {
    collapsedLabel: {default: 'Show More'},
    expandedLabel: {default: 'Show Less'},
    initialHeight: {type: Number, default: 100},
    textOnly: {type: Boolean, default: false}
  },

  data() {
    return {
      hidden: true,
      actualHeight: 0
    };
  },

  computed: {
    label() {
      return this.hidden ? this.collapsedLabel : this.expandedLabel;
    },

    contentFits() {
      return this.actualHeight <= this.initialHeight;
    },

    height() {
      let height = this.initialHeight;

      if (this.hidden) {
        height: this.contentFits ? this.actualHeight : this.initialHeight;
      } else {
        // It's open, show the whole thing
        height = this.actualHeight;
      }

      return height;
    }
  },

  methods: {
    toggle() {
      this.hidden = !this.hidden;
    },

    toggleIfHidden() {
      if (this.hidden) {
        this.toggle();
      }
    },

    updateSize() {
      this.actualHeight = this.$refs.showMoreContainer.childNodes[0].offsetHeight;
    },

    expand() {
      this.hidden = false;
    }
  },

  mounted() {
    this.updateSize();
    this.hidden = !this.contentFits; // Only update hidden status when mounted, otherwise it'll hide when the window is resized

    window.addEventListener("resize", this.updateSize);
  },

  destroyed() {
    window.removeEventListener("resize", this.updateSize);
  }

}
</script>
